import React from 'react';
import { StyledSource } from './styles/common.styles';

const CallSource = ({ source }) => (
  <StyledSource data-name="location-source">Source: {source}</StyledSource>
);

export default CallSource;
